import React, { useEffect, useState } from "react";
import { clear, getPickupTask } from "../../../slices/Liv.slice";
import { loadLoggedUser } from "../../../slices/Auth";
import { useDispatch, useSelector } from "react-redux";
import { ColisStatus, ColisStatusBg, colisStatusLabels } from "../../../utils/constants/Colis.enum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "react-bootstrap";

const MovableLivContainer = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.liv);
  const { loggedUser } = useSelector((state) => state.auth);
  const [lst_mu, set_lst_mu] = useState(null);
  const [nbr_colis_pick, set_nbr_colis_pick] = useState(0);
  const [show_details, set_show_details] = useState(false);
  const [sel_item, set_sel_item] = useState(false);

  const load_pickup = () => {
    dispatch(getPickupTask())
      .unwrap()
      .then((res) => {
        console.log(res);
        set_lst_mu(Array.isArray(res?.mv) ? res?.mv : []);
      })
      .catch((err) => console.log(err));
  };

  const onViewMu = (mu) => {
    set_sel_item(mu);
    set_show_details(true);
  };

  const onCloseDetails = () => {
    set_sel_item(null);
    set_show_details(false);
  };

  useEffect(() => {
    dispatch(loadLoggedUser());
    load_pickup();
  }, []);

  useEffect(() => {
    if(Array.isArray(lst_mu)){
      let tmp = lst_mu.reduce((acc, curr) => Array.isArray(curr?.colis) ? +acc + curr?.colis?.length : acc , 0)
      set_nbr_colis_pick(tmp)
    }
  }, [lst_mu]);

  return (
    <div className="row m-0">
      <div className="col-12 text-center">
        <Card className="mt-2">
          <Card.Body>
            <div className="row m-0">
              <div className="col-6">
                <h6 className="fnt-w5">Ramassage</h6>
              </div>

              <div className="col-6 brd-l-1">
                <h6>{nbr_colis_pick} <b className="text-success fnt-sm fnt-w5" style={{marginTop : -8}}>colis</b></h6>
                
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>

      <div className="col-12">
        {Array.isArray(lst_mu) && lst_mu?.map(el => <MuItem mu={el} onViewDetails={onViewMu} key={el?.id} />)}
      </div>

      <MuDetails mu={sel_item} show={show_details} onClose={onCloseDetails} />
      </div>
  );
};

const MuItem = ({mu , onViewDetails}) => {
  return(
    <Card className="mt-1 p-0" style={{cursor : 'pointer'}} onClick={e => onViewDetails(mu)}>
      <Card.Body className="p-1">
         <div className="row m-0">
            <div className="col-auto text-center pt-3">
                <span className={`d-inline-block p-1 bg-warning`} style={{color : 'white', width : 32, height :32, borderRadius : '100%'}}>
                    <FontAwesomeIcon icon={['fas', 'truck']} />
                </span>
            </div>

            <div className="col-10 brd-l-1 text-start pe-1">
              <h6 className="fnt-w6 m-0">{mu?.ref}
              <span className="float-end" style={{ clipPath: "polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)", width: 24, height: 24, background: "#263238", display: "inline-block" }}></span>

              </h6>
              <h6 className="fnt-w5 fnt-sm text-muted" style={{marginTop : -2}}>{`${mu?.mvExped?.nom_com}`}</h6>
              <h6 className="fnt-w5 fnt-sm m-0 dvdr-t-gray pt-1"><FontAwesomeIcon icon={['fas', 'map-marker-alt']} /> {`${mu?.mvExped?.adresse}`}</h6>
              <h6 className="fnt-w5 fnt-sm text-success" style={{marginTop : 0}}><FontAwesomeIcon icon={['fas', 'mobile']} /> {`${mu?.mvExped?.tel}`} <span className="float-end">{Array.isArray(mu?.colis) ? mu?.colis?.length : '---'} Colis</span></h6>
            </div>
         </div>
      </Card.Body>
    </Card>
  )
}


const MuDetails = ({ mu, show, onClose }) => {


  return (
    <div className={show ? "col-12 bg-gray inf_box_pop_r" : "col-12 bg-gray inf_box_pop_r inf_box_pop_r_off"}>
      <div className="row p-0 m-0 bg-gray">
        <button className="btn_close" onClick={onClose}>
          <FontAwesomeIcon icon={["fas", "chevron-right"]} />
        </button>
      </div>

      <div className="col-12  p-2 bg-wt ">
        <div className="row m-0">
            <div className="col-auto text-center pt-1">
                <span className={`d-inline-block p-1 bg-success`} style={{color : 'white', width : 32, height :32, borderRadius : '100%'}}>
                    <FontAwesomeIcon icon={['fas', 'truck']} />
                </span>
            </div>
            <div className="col-10 brd-l-1 text-start pe-1">
              <h6 className="fnt-w6 m-0">{mu?.ref}</h6>
              <h6 className="fnt-w5 fnt-sm text-muted" style={{marginTop : -2}}>{`${mu?.mvExped?.nom_com}`}</h6>
            </div>
        </div>
        <div className="row m-0">
            <div className="col-12  text-start pe-1">
              <h6 className="fnt-w5 fnt-sm m-0 dvdr-t-gray pt-2"><FontAwesomeIcon icon={['fas', 'map-marker-alt']} /> {`${mu?.mvExped?.adresse}`}</h6>
              <span className="float-end mt-1"><a className="btn btn-sm btn-success fnt-sm px-4" href={`tel:${mu?.mvExped?.tel_cl}`}>Appeler</a></span>
              <h6 className="fnt-w5  text-success dvdr-t-gray py-2" style={{marginTop : 0}}><FontAwesomeIcon icon={['fas', 'mobile']} /> {`${mu?.mvExped?.tel}`} </h6>
              <h6 className="fnt-w5  text-center dvdr-t-gray py-2" style={{marginTop : 0}}> {`${Array.isArray(mu?.colis) ? mu?.colis?.length : '---'} Colis`} </h6>
            </div>
         </div>
         <div className="row m-0">
          {Array.isArray(mu?.colis) && mu?.colis?.map(el => 
            <Card key={el?.ref} className="p-0 mt-1">
              <Card.Body>
                  <div className="row m-0">
                      <div className="col-12">
                         <h6 className="m-0 text-success"><span><FontAwesomeIcon icon={['fas', 'barcode']} /> </span> {el?.code}</h6>
                         <h6 className="m-0 text-muted fnt-sm">{el?.nom_cl} {el?.prenom_cl}</h6>
                         <h6 className="fnt-w5 fnt-sm m-0 dvdr-t-gray pt-1"><FontAwesomeIcon icon={['fas', 'map-marker-alt']} /> {`${el?.adresse}, ${el?.adresse_gov}, ${el?.adresse_deleg}`}</h6>

                      </div>
                  </div>
              </Card.Body>
            </Card>
          )}
         </div>
      </div>
    </div>
  );
};

export default MovableLivContainer;
